import * as React from 'react';
import classNames from 'classnames';
import get from 'lodash/get';
import { getWidth } from '@/utils/element';
import { useGuid } from '@/utils/use-guid';
import { withNativeProps } from '@/utils/with-native-props';
import { CnStepItem } from './cn-step-item';
import { getStepCurrent } from './utils';
import './cn-step.scss';
/**
 * @category 组件
 * @description 步骤组件
 */
export const CnStep = (props) => {
    const { direction, shape, children, disabled, onChange, contentRender } = props;
    const [isOverflow, setOverflow] = React.useState(false);
    const classes = {
        step: classNames('cn-ui-m-step', {
            'cn-ui-m-step--scroll': isOverflow,
        }),
        container: classNames('cn-ui-m-step-container', `cn-ui-m-step-container--${direction}`, {
            'cn-ui-m-step-container--scroll': isOverflow,
        }),
    };
    const validChildren = React.Children.toArray(children)
        .filter(React.isValidElement)
        .filter((child) => {
        return child.type === CnStepItem;
    }) || [];
    const childrenCount = validChildren.length;
    const current = getStepCurrent(props);
    const disabledIndexes = validChildren
        .map((child, index) => {
        return disabled || get(child, 'props.disabled') ? index : null;
    })
        .filter((item) => item !== null);
    const stepId = useGuid('step-');
    const stepContainerId = useGuid('step-container-');
    React.useEffect(() => {
        (async () => {
            const containerWidth = await getWidth(stepContainerId);
            const width = document.getElementById(stepId)?.scrollWidth || 0;
            setOverflow(width > containerWidth);
        })();
    });
    const renderChildren = () => {
        return validChildren.map((child, index) => {
            const childProps = child.props;
            const { disabled: childDisabled, status: childStatusProp, className: childClassName, onClick: childOnClick, ...others } = childProps;
            let status = childStatusProp;
            if (!childStatusProp) {
                status = 'wait';
                if (index === current) {
                    status = 'process';
                }
                else if (index < current) {
                    status = 'finish';
                }
            }
            return React.cloneElement(child, {
                key: `cn_ui_m_step_${index}`,
                ...others,
                order: index,
                isFirst: index === 0,
                isLast: index === childrenCount - 1,
                isPreDisabled: disabledIndexes.indexOf(index - 1) > -1,
                shape,
                direction,
                status,
                contentRender,
                onClick: () => {
                    if (childOnClick) {
                        childOnClick(index);
                    }
                    if (onChange && !disabled && !childDisabled) {
                        onChange(index);
                    }
                },
                className: classNames(childClassName, `cn-ui-m-step-item--${direction}`),
            });
        });
    };
    return withNativeProps(props, React.createElement("div", { id: stepContainerId, className: classes.step },
        React.createElement("div", { id: stepId, className: classes.container }, renderChildren())));
};
CnStep.displayName = 'CnStep';
CnStep.defaultProps = {
    direction: 'hoz',
    shape: 'circle',
    disabled: false,
};
